<script setup>
import Menu from "./modals/Menu.vue";
import Logout from "./modals/Logout.vue";
import Notifications from "./modals/Notifications.vue";
import OrderFilters from "./modals/OrderFilters.vue";
import Ticket from "./modals/Tickets/Ticket.vue";
import CompleteTicket from "./modals/Tickets/CompleteTicket.vue";
import AssignTicket from "./modals/Tickets/AssignTicket.vue";
import TicketAddNote from "./modals/Tickets/TicketAddNote.vue";
import BulkAssignTicket from "./modals/Tickets/BulkAssignTicket.vue";
import BulkCompleteTicket from "./modals/Tickets/BulkCompleteTicket.vue";
import TicketFilters from "./modals/Tickets/TicketFilters.vue";
import Call from "./modals/Calls/Call.vue";

import {useModalStore} from "../store/modal.js";
import {computed} from "vue";
import {useAuthStore} from "../store/auth.js";
import User from "./modals/Users/User.vue";
import AddUser from "./modals/Users/AddUser.vue";
import EditUser from "./modals/Users/EditUser.vue";
import DeleteUser from "./modals/Users/DeleteUser.vue";
import UserFilters from "./modals/Users/UserFilters.vue";
import AssignCall from "./modals/Calls/AssignCall.vue";
import CompleteCall from "./modals/Calls/CompleteCall.vue";
import BulkAssignCall from "./modals/Calls/BulkAssignCall.vue";
import BulkCompleteCall from "./modals/Calls/BulkCompleteCall.vue";
import CallFilters from "./modals/Calls/CallFilters.vue";
import CallAddNote from "./modals/Calls/CallAddNote.vue";
import CallReschedule from "./modals/Calls/CallReschedule.vue";
import CreateCall from "./modals/Calls/CreateCall.vue";
import MessageAttachement from "./modals/MessageAttachement.vue";
import MessageAttachmentInput from "./modals/MessageAttachmentInput.vue";
import Chat from "./modals/Chats/Chat.vue";
import CreateChat from "./modals/Chats/CreateChat.vue";
import ManualCreateChat from "./modals/Chats/ManualCreateChat.vue";
import ChatAddNote from "./modals/Chats/ChatAddNote.vue";
import AssignChat from "./modals/Chats/AssignChat.vue";
import CompleteChat from "./modals/Chats/CompleteChat.vue";
import BlockChatContact from "./modals/Chats/BlockChatContact.vue";
import SendTemplateMessage from "./modals/Chats/SendTemplateMessage.vue";
import DormantOrder from "./modals/Orders/DormantOrder.vue";
import UnprocessOrder from "./modals/Orders/UnprocessOrder.vue";
import BulkSendWizard from "./modals/BulkSends/BulkSendWizard.vue";

const components = {
    "Menu": Menu,
    "Logout": Logout,
    "Notifications": Notifications,
    "OrderFilters": OrderFilters,
    "CreateCall": CreateCall,
    "Ticket": Ticket,
    "CompleteTicket": CompleteTicket,
    "AssignTicket": AssignTicket,
    "TicketAddNote": TicketAddNote,
    "BulkAssignTicket": BulkAssignTicket,
    "BulkCompleteTicket": BulkCompleteTicket,
    "TicketFilters": TicketFilters,
    "User": User,
    "AddUser": AddUser,
    "EditUser": EditUser,
    "DeleteUser": DeleteUser,
    "UserFilters": UserFilters,
    "Call": Call,
    "AssignCall": AssignCall,
    "CompleteCall": CompleteCall,
    "BulkAssignCall": BulkAssignCall,
    "BulkCompleteCall": BulkCompleteCall,
    "CallFilters": CallFilters,
    "CallAddNote": CallAddNote,
    "CallReschedule": CallReschedule,
    "MessageAttachment": MessageAttachement,
    "MessageAttachmentInput": MessageAttachmentInput,
    "Chat": Chat,
    "CreateChat": CreateChat,
    "DormantOrder": DormantOrder,
    "UnprocessOrder": UnprocessOrder,
    "ManualCreateChat": ManualCreateChat,
    "ChatAddNote": ChatAddNote,
    "AssignChat": AssignChat,
    "CompleteChat": CompleteChat,
    "BlockChatContact": BlockChatContact,
    "SendTemplateMessage": SendTemplateMessage,
    "BulkSendWizard": BulkSendWizard
}
const modal = useModalStore()
const auth = useAuthStore()
const is = computed(() => components[modal.active_modal])
const need_container = computed(() => !['Ticket', 'User', 'Call', 'MessageAttachment', 'MessageAttachmentInput', 'Chat'].includes(modal.active_modal))
</script>

<template>
    <div :class="[{'modal-container':need_container}]">
        <teleport :to="modal.anchor_el" v-if="modal.anchor_el">
            <component :is="is" :class="`modal-body --position-${modal.placement}`"/>
        </teleport>
        <component :is="is" :class="`modal-body --position-${modal.placement}`" v-else/>
    </div>
</template>

<style scoped lang="scss">
.modal-container {
    background: var(--color-black-70);
    backdrop-filter: blur(1rem);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    //display: none;
}

.modal-body {
    z-index: 99999999999;
    position: fixed;

    &.--position-center {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    &.--position-top-left {
        top: 0;
        left: 0;
    }

    &.--position-top-right {
        top: 0;
        right: 0;
    }

    &.--position-bottom-left {
        bottom: 0;
        left: 0;
    }

    &.--position-bottom-right {
        bottom: 0;
        right: 0;
    }

    &.--position-center-top {
        top: 0;
        left: 50%;
        transform: translateX(-50%);
    }

    &.--position-center-left {
        bottom: 50%;
        left: 0;
        transform: translateY(-50%);
    }

    &.--position-center-bottom {
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>
